import React from "react";
import "./style/TestimonialSection.css";

const testimonials = [
  {
    name: "Michael S.Customer",
    image: "/assets/michel.webp",
    rating: 5,
    feedback:
      "Absolutely fantastic service! My office Interior Design is so Faboulous. The designing service was top-notch. Highly recommend!",
  },
  {
    name: "Robert L.Customer",
    image: "/assets/robert.webp",
    rating: 5,
    feedback:
      "Absolutely fantastic service! I Availed Insect Mosquito Protection Service is top-notch. Highly recommend!",
  },
  {
    name: "Jake M.Customer",
    image: "/assets/jake.webp",
    rating: 5,
    feedback:
      "Absolutely fantastic service! Pest Control service in my hotel done excellently. Highly recommend!",
  },
  {
    name: "Alex P.Customer",
    image: "/assets/alex.webp",
    rating: 5,
    feedback:
      "Absolutely fantastic Designing! My College Interior Design and furniture collection is so impressive and excellent. Highly recommend!",
  },
];

const TestimonialSection = () => {
  return (
    <section className="testimonial-section">
      <div className="container text-center">
        <p className="section-tag" data-aos="fade-up">TESTIMONIALS</p>
        <h2 className="section-title" data-aos="fade-up" data-aos-delay="100">Our Happy Customers</h2>

        {/* Desktop Grid */}
        <div className="row mt-5 d-none d-md-flex">
          {testimonials.map((item, index) => (
            <div
              className="col-lg-3 col-md-6 mb-4"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="testimonial-box d-flex flex-column align-items-start">
                <img src={item.image} alt={item.name} className="testimonial-img" />
                <h5 className="testimonial-name">{item.name}</h5>
                <div className="stars mb-2">
                  {[...Array(item.rating)].map((_, i) => (
                    <span key={i}>⭐</span>
                  ))}
                </div>
                <p className="testimonial-text">{item.feedback}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Carousel */}
        <div
          id="testimonialCarousel"
          className="carousel slide d-md-none mt-4"
          data-bs-ride="carousel"
          data-bs-interval="3000"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className="carousel-inner">
            {testimonials.map((item, index) => (
              <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={index}>
                <div className="testimonial-box d-flex flex-column align-items-center">
                  <img src={item.image} alt={item.name} className="testimonial-img" />
                  <h5 className="testimonial-name">{item.name}</h5>
                  <div className="stars mb-2">
                    {[...Array(item.rating)].map((_, i) => (
                      <span key={i}>⭐</span>
                    ))}
                  </div>
                  <p className="testimonial-text">{item.feedback}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Carousel Controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#testimonialCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#testimonialCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
